// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_errors.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file call/call_errors.proto.
 */
export const file_call_call_errors: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChZjYWxsL2NhbGxfZXJyb3JzLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCIpCgxCZmZDYWxsRXJyb3IaGQoXSGFzTm9QZXJtaXNzaW9uc0ZvckNhbGxCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.BffCallError
 */
export type BffCallError = Message<'com.gem.bff.contract.BffCallError'> & {};

/**
 * Describes the message com.gem.bff.contract.BffCallError.
 * Use `create(BffCallErrorSchema)` to create a new message.
 */
export const BffCallErrorSchema: GenMessage<BffCallError> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0);

/**
 * @generated from message com.gem.bff.contract.BffCallError.HasNoPermissionsForCall
 */
export type BffCallError_HasNoPermissionsForCall =
  Message<'com.gem.bff.contract.BffCallError.HasNoPermissionsForCall'> & {};

/**
 * Describes the message com.gem.bff.contract.BffCallError.HasNoPermissionsForCall.
 * Use `create(BffCallError_HasNoPermissionsForCallSchema)` to create a new message.
 */
export const BffCallError_HasNoPermissionsForCallSchema: GenMessage<BffCallError_HasNoPermissionsForCall> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 0);
